import React, { useCallback } from "react";

import { useQueryGetVocabulary } from "@examspark/common-app";
import { Button } from "@examspark/common-ui";
import { VocabularyItem } from "@examspark/types";

import Modal from "../common/Modal";

import VocabularyDetail from "./VocabularyDetail";

type Props = {
  vocabularyList: VocabularyItem[] | undefined;
  showIndex: number | undefined;
  onShowIndexChange: (showIndex: number | undefined) => void;
};

const VocabularyDetailModal = ({
  vocabularyList,
  showIndex,
  onShowIndexChange,
}: Props) => {
  const vocabularyId = vocabularyList?.[showIndex ?? -1]?.id;

  const result = useQueryGetVocabulary(vocabularyId, "vocabulary");

  const onIncrementShowIndex = useCallback(
    (increment: 1 | -1) => {
      if (vocabularyList == null || showIndex == null) return;

      const newShowIndex = showIndex + increment;
      if (newShowIndex < 0 || newShowIndex >= vocabularyList?.length) return;
      onShowIndexChange(newShowIndex);
    },
    [onShowIndexChange, showIndex, vocabularyList],
  );

  return (
    <Modal
      isOpen={showIndex != null}
      title="Vocabulary Detail"
      onRequestClose={() => onShowIndexChange(undefined)}
      size="large"
      buttons={
        <Button onClick={() => onShowIndexChange(undefined)} title="Close">
          Close
        </Button>
      }
      titlebarToolbar={
        <>
          {(showIndex ?? -1) + 1} of {vocabularyList?.length}
        </>
      }
      showPagination={true}
      onNext={() => onIncrementShowIndex(1)}
      onPrevious={() => onIncrementShowIndex(-1)}
    >
      <Modal.PaddedBody>
        <VocabularyDetail
          vocabulary={result.data}
          onBrowseResultNavigate={() => onShowIndexChange(undefined)}
        />
      </Modal.PaddedBody>
    </Modal>
  );
};

export default VocabularyDetailModal;
